import { Link } from '#components/atoms/link/Link.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';

type Props = {
  value: string;
};

export function TOTPActionMenu({ value }: Props) {
  return (
    <MeatballMenu>
      <MenuItem render={<Link to={`totps/${value}/edit`} />}>Edit</MenuItem>
      <MenuItem render={<Link to={`totps/${value}/delete`} />}>Delete</MenuItem>
    </MeatballMenu>
  );
}
